'use strict';

export default angular.module('NewLinkCtrl', [])
	.controller('NewLinkController', ['$scope', '$modalInstance', '$filter', 'Flash', 'aliases',
		function($scope, $modalInstance, $filter, Flash, aliases) {
			$scope.newLink = {
				ALIAS_1: "",
				ALIAS_1_ANY: 0,
				ALIAS_1_ID: 0,
				ALIAS_2: "",
				ALIAS_2_ID: 0,
				PRIORITY: 0,
				MAX_AGE: "",
				MAX_OBSERVATIONS: "",
				MIN_VALUE: "",
				MAX_VALUE: ""
			};
			$scope.aliases = aliases;
			$scope.ok = function () {
				var checkIfEmpty = function(val) {
					return angular.isUndefined(val) || val === null || val === "";
				}
				var decimalPattern = new RegExp("^[0-9]+(\.[0-9]+)?$");
				var integerPattern = new RegExp("^[0-9]+$");
				if((($scope.newLink.ALIAS_1 && $scope.newLink.ALIAS_1.originalObject) || $scope.newLink.ALIAS_1_ANY != 0)
					&& ($scope.newLink.ALIAS_2 && $scope.newLink.ALIAS_2.originalObject)) {
					// Check if maxAge and maxObservations contain integers
					if((checkIfEmpty($scope.newLink.MAX_OBSERVATIONS) || integerPattern.test($scope.newLink.MAX_OBSERVATIONS.toString()))
						&& (checkIfEmpty($scope.newLink.PRIORITY) || integerPattern.test($scope.newLink.PRIORITY.toString()))
						&& (checkIfEmpty($scope.newLink.MAX_AGE) || integerPattern.test($scope.newLink.MAX_AGE.toString()))) {
						// Check if minValue and maxValue contain numbers
						if((checkIfEmpty($scope.newLink.MIN_VALUE) || decimalPattern.test($scope.newLink.MIN_VALUE.toString().replace(',', '.')))
							&& (checkIfEmpty($scope.newLink.MAX_VALUE) || decimalPattern.test($scope.newLink.MAX_VALUE.toString().replace(',', '.')))) {
							$modalInstance.close($scope.newLink);
						}
						else {
							Flash.create("warning", $filter('translate')('ERROR_INT_OR_DEC_ONLY') +
								$filter('translate')('MIN_VALUE') + ", " + $filter('translate')('MAX_VALUE'),
								$filter('translate')('ERROR_CHECK_INFORMATION'));
						}
					}
					else {
						Flash.create("warning", $filter('translate')('ERROR_INT_ONLY') +
							$filter('translate')('PRIORITY') +
							", " + $filter('translate')('MAX_AGE') +
							", " + $filter('translate')('MAX_AMOUNT'),
							$filter('translate')('ERROR_CHECK_INFORMATION'));
					}
				}
				else {
					Flash.create("warning", $filter('translate')('ERROR_MISSING_INFO_TEXT') +
						$filter('translate')('ALIAS1') + ", " + $filter('translate')('ALIAS2'),
						$filter('translate')('ERROR_MISSING_INFO_TITLE'));
				}
			};
			$scope.cancel = function() {
				$modalInstance.dismiss("cancel");
			};
		}
	]);